import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  KEEP_THE_SAME,
  StateStatus,
} from '../../utils/common';
import * as AdminDashboardService from '../../../services/api/admin_dashboard';

interface IFetchAdminDashboardDataAction
  extends AdminDashboardService.IAdminDashboardDataInput {
  onSuccess?: () => void;
}
class FetchAdminDashboardData implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_ADMIN_DASHBOARD_DATA,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }

  onSuccess(data: any): IAction {
    return {
      type: Types.SET_ADMIN_DASHBOARD_DATA,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_ADMIN_DASHBOARD_DATA,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IFetchAdminDashboardDataAction): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await AdminDashboardService.fetchAdminDashboardData(
          payload
        );
        dispatch(
          this.onSuccess({
            ...response.data,
            filters: payload,
          })
        );
        payload.onSuccess && payload.onSuccess();
      } catch (error: any) {
        // console.log('Fetch AdminDashboardData Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

interface IFetchTraderDashboardDataAction {
  onSuccess?: () => void;
}
class FetchTraderDashboardData implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_TRADER_DASHBOARD_DATA,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }

  onSuccess(data: any): IAction {
    return {
      type: Types.SET_TRADER_DASHBOARD_DATA,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_TRADER_DASHBOARD_DATA,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await AdminDashboardService.fetchTraderDashboardData();
        dispatch(
          this.onSuccess({
            ...response.data,
          })
        );
      } catch (error: any) {
        dispatch(this.onFailed());
      }
    };
  }
}

export default {
  fetchAdminDashboardDataAction: (payload: IFetchAdminDashboardDataAction) =>
    new FetchAdminDashboardData().action(payload),
  fetchTraderDashboardDataAction: () => new FetchTraderDashboardData().action(),
};
